import { COLOR } from 'vars/index'

export const AuthLayoutJustifyContent = {
  FlexStart: 'flex-start',
  Center: 'center',
  FlexEnd: 'flex-end',
  SpaceBetween: 'space-between',
  SpaceAround: 'space-around',
  SpaceEvenly: 'space-evenly',
} as const
export type AuthLayoutJustifyContent =
  (typeof AuthLayoutJustifyContent)[keyof typeof AuthLayoutJustifyContent]

export const AuthLayoutAlignItems = {
  FlexStart: 'flex-start',
  Center: 'center',
  FlexEnd: 'flex-end',
  Baseline: 'baseline',
} as const
export type AuthLayoutAlignItems =
  (typeof AuthLayoutAlignItems)[keyof typeof AuthLayoutAlignItems]

export const AuthLayoutOverlayColors = {
  BANNER_HORIZONTAL_OVERLAY: COLOR.BANNER_HORIZONTAL_OVERLAY,
  BANNER_VERTICAL_OVERLAY: COLOR.BANNER_VERTICAL_OVERLAY,
} as const
export type AuthLayoutOverlayColors =
  (typeof AuthLayoutOverlayColors)[keyof typeof AuthLayoutOverlayColors]

export const AuthLayoutBackgroundColors = {
  BACKGROUND_DARK_APP: COLOR.BACKGROUND_DARK_APP,
} as const
export type AuthLayoutBackgroundColors =
  (typeof AuthLayoutBackgroundColors)[keyof typeof AuthLayoutBackgroundColors]
